'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _dotPropImmutable = require('dot-prop-immutable');

var _dotPropImmutable2 = _interopRequireDefault(_dotPropImmutable);

var _context = require('../../constants/reducers/context');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var initialState = {
	subfolderPrefix: process.env.REACT_APP_SUBFOLDER_NAME ? '/' + process.env.REACT_APP_SUBFOLDER_NAME : '',
	configuration: null,
	analytics: null,
	session: null,
	parameters: [],
	operation: null,
	loading: [],
	error: [],
	scriptCache: [],
	storefrontUrl: null
};

function contextReducer() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _context.REDUCE_LOCATION:
			return _dotPropImmutable2.default.set(state, 'location', action.payload);
		case _context.REDUCE_CONFIGURATION:
			return _dotPropImmutable2.default.set(state, 'configuration', action.payload);
		case _context.REDUCE_ANALYTICS:
			return _dotPropImmutable2.default.set(state, 'analytics', action.payload);
		case _context.REDUCE_CULTURE:
			return _dotPropImmutable2.default.set(state, 'session.culture', action.payload);
		case _context.REDUCE_SESSION:
			return _dotPropImmutable2.default.set(state, 'session', action.payload);
		case _context.REDUCE_PARAMETERS:
			return _dotPropImmutable2.default.set(state, 'parameters', action.payload);
		case _context.REDUCE_OPERATION:
			if (action.payload) {
				action.payload.createdOn = new Date();
			}
			return _dotPropImmutable2.default.set(state, 'operation', action.payload);
		case _context.REDUCE_LOADING:
			if (state.loading.some(function (x) {
				return x.code === action.payload.code;
			})) {
				return _dotPropImmutable2.default.set(state, 'loading.' + state.loading.findIndex(function (x) {
					return x.code === action.payload.code;
				}), action.payload);
			} else {
				return _dotPropImmutable2.default.set(state, 'loading', [action.payload].concat(_toConsumableArray(state.loading)));
			}
		case _context.REDUCE_SCRIPT_CACHE:
			return _dotPropImmutable2.default.set(state, 'scriptCache', action.payload);
		case _context.REDUCE_STOREFRONT_URL:
			return _dotPropImmutable2.default.set(state, 'storefrontUrl', action.payload);
		default:
			return state;
	}
}

exports.default = contextReducer;